var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stask-name-input",class:_vm.classes},[_c('h1',{ref:"input",attrs:{"contenteditable":"true"},on:{"focusin":_vm.focusin,"focusout":_vm.focusout,"keydown":_vm.handleKey,"paste":_vm.handlePaste}},[_vm._v(_vm._s(_vm.task.description))]),_c('i',{staticClass:"alertIcon fa fa-exclamation-triangle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }